import CompanyDetailsCollections from './CompanyDetailsCollections';

export default CompanyDetailsCollections;
